import { Inbox } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';

/**
 * Shared "No data in period" empty state. Used across the Dashboard, Revenue and Order
 * all-restaurants cards so every empty surface reads the same: a muted icon + label,
 * centered, with consistent spacing.
 */
export const NoDataInPeriod = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <div className={cn('w-full flex flex-col items-center justify-center gap-2 py-10 text-center', className)}>
      <Inbox className="w-6 h-6 text-textTertiary dark:text-textTertiary-dark" />
      <span className="text-sm font-medium text-muted dark:text-muted-dark">
        {t('common.noDataInPeriod')}
      </span>
    </div>
  );
};

export default NoDataInPeriod;
